import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Button, Select } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { useSWRidget } from 'src/hooks/useSWRidget';
import action from '@flux/action';
import Loading from '@components/loading';
import SectionComment from 'src/ddvComment/SectionComment';
import SectionWidget from '@components/sectionWidget/SectionWidget';
import FullScreenButton from '@components/fullScreenButton';
import './visualWidget.scss';
import AnchorComponent from '@modules/customizedModule/anchorComponent';
import { ChartWidgetOptions } from '@model/sectionWidget.model';

const { Option } = Select;

const VisualWidget = (props) => {
  const dispatch = useDispatch();

  const history = useHistory();
  const url = history.location?.search;
  const param = new URLSearchParams(url);
  const projectId = param.get('projectId');
  const moduleId = param.get('moduleValue');
  const defaultLink = param.get('link');

  const [widgetLink, setWidgetLink] = useState(null);
  const [chartType, setChartType] = useState(null);
  const [forceUpdate, setForceUpdate] = useState(false);

  const operatorName = useSelector((state) => state.login.userInfo.name);
  const moduleInfo = useSelector((state) =>
    state.projects.customizedModules.filter(
      (module) => module.value === moduleId,
    ),
  )[0];
  const { widgetData, createWidget, saveWidget } = useSWRidget(
    !widgetLink ? null : widgetLink,
  );

  useEffect(() => {
    if (!widgetLink || defaultLink === 'empty-widget') {
      setWidgetLink(defaultLink === 'empty-widget' ? null : defaultLink);
      setChartType(null);
    } else {
      setForceUpdate(true);
      setWidgetLink(defaultLink);
      setTimeout(() => {
        setForceUpdate(false);
      }, 1000);
    }
  }, [defaultLink]);

  useEffect(() => {
    if (widgetData) {
      setChartType(widgetData.chartType);
    }
  }, [widgetData]);

  const handleCreateWidget = async () => {
    const newLink = await createWidget(chartType, moduleId, 'Section');
    setWidgetLink(newLink);
    //@projectSetting.js: 填表修改module，可以做新借口替代
    const projectData = await dispatch(action.getProjectSetting(projectId));
    const newData = {
      clientSetting: projectData.clientInfo,
      groupSetting: projectData.groups.map((item) => {
        if (!item.groupInfo) {
          item.groupInfo = {};
        }
        item.groupInfo.projectId = projectId;
        return item;
      }),
      projectSetting: projectData.projectInfo,
      teamSetting: {
        members: [
          projectData.teamInfo.lead,
          projectData.teamInfo.manager,
          ...projectData.teamInfo.members,
        ].filter((member) => member != null && member != undefined),
        operatorName,
      },
      moduleSetting: [],
    };

    const defaultPermission = projectData.groups.map((group) => ({
      groupId: group.groupInfo.id,
      groupPermission: [],
    }));

    for (module in projectData.moduleInfo) {
      if (projectData.moduleInfo[module].value === moduleId) {
        if (projectData.moduleInfo[module].groupPermissions) {
          newData.moduleSetting.push({
            ...projectData.moduleInfo[module],
            link: newLink,
          });
        } else {
          newData.moduleSetting.push({
            ...projectData.moduleInfo[module],
            groupPermissions: defaultPermission,
            link: newLink,
          });
        }
        continue;
      }
      if (projectData.moduleInfo[module].groupPermissions) {
        newData.moduleSetting.push(projectData.moduleInfo[module]);
      } else {
        newData.moduleSetting.push({
          ...projectData.moduleInfo[module],
          groupPermissions: defaultPermission,
        });
      }
    }

    const { success, hasAuth } = await dispatch(
      action.saveProjectSettings(newData),
    );
  };

  const handleSaveWidget = (data) => {
    setForceUpdate(true);
    saveWidget(data);
    setTimeout(() => {
      setForceUpdate(false);
    }, 1000);
  };

  if (!widgetLink) {
    return (
      <div className="page-wrapper visualization-widget">
        <div className="visual-widget-head">
          <span className="dd-back-btn" onClick={history.goBack}>
            <span className="appkiticon icon-left-chevron-fill a-font-12" />
            Back
          </span>
          <SectionComment
            module={moduleInfo.module}
            component=""
            placement="bottomRight"
            sendIdentifier={moduleId}
          />
          <AnchorComponent anchorId={moduleId} key={moduleId} />
        </div>
        <div className="visual-widget-content">
          <div className="selector-wrapper">
            <Select
              placeholder="Select visualization type​"
              dropdownClassName="widget-selector-dropdown"
              className="widget-selector"
              dropdownMatchSelectWidth
              value={chartType}
              onChange={setChartType}
            >
              {ChartWidgetOptions.map(({ value, label, icon }) => (
                <Option value={value} key={`chart-option-${value}`}>
                  <span className={`appkiticon ${icon} a-font-12`} /> {label}
                </Option>
              ))}
            </Select>
            <Button
              type="primary"
              className="generate-widget-btn"
              onClick={handleCreateWidget}
              disabled={!chartType}
            >
              Create
            </Button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="page-wrapper visualization-widget">
      <div className="visual-widget-head">
        <span className="dd-back-btn" onClick={history.goBack}>
          <span className="appkiticon icon-left-chevron-fill a-font-12" />
          Back
        </span>
        <SectionComment
          module={moduleInfo.module}
          component=""
          placement="bottomRight"
          sendIdentifier={moduleId}
        />
        <AnchorComponent anchorId={moduleId} key={moduleId} />
        <FullScreenButton elemId={`#widget-field-${widgetLink}`} />
      </div>
      <div className="visual-widget-content">
        <div className="content-wrapper" id={`widget-field-${widgetLink}`}>
          {chartType && widgetData && !forceUpdate ? (
            <SectionWidget
              chartType={chartType}
              data={widgetLink ? widgetData.data : null}
              handleSave={handleSaveWidget}
            />
          ) : (
            <Loading />
          )}
        </div>
      </div>
    </div>
  );
};

export default VisualWidget;
